import { push, $ } from '../helpers';
/**
 * Push a success Toast
 * @param {string} body
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var success = function (body, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    if (useI18n)
        $.snotify.success($.t(body), title ? $.t(title) : undefined, config);
    else
        $.snotify.success(body, title || undefined, config);
};
/**
 * Push a success Toast and go to a given uri vue-router
 * @param {string} body
 * @param {string} uri
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var successAndPush = function (body, uri, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    success(body, title, useI18n, config);
    push(uri);
};
/**
 * Push an error Toast
 * @param {string} body
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var error = function (body, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    if (useI18n)
        $.snotify.error($.t(body), title ? $.t(title) : undefined, config);
    else
        $.snotify.error(body, title || undefined, config);
};
/**
 * Push an error Toast using Validation Label
 * @param {string} message
 */
export var errorValidation = function (message) { return error(message, $.t('system.error.validation'), false); };
/**
 * Push an error Toast and go to a given uri vue-router
 * @param {string} body
 * @param {string} uri
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var errorAndPush = function (body, uri, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    error(body, title, useI18n, config);
    push(uri);
};
/**
 * Show an error and interrupt the code
 * @param {string} body
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var abort = function (body, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    error(body, title, useI18n, config);
    throw new Error(useI18n ? $.t(body) : body);
};
/**
 * Push a warning Toast
 * @param {string} body
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var warning = function (body, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    if (useI18n)
        $.snotify.warning($.t(body), title ? $.t(title) : undefined, config);
    else
        $.snotify.warning(body, title || undefined, config);
};
/**
 * Push a warning Toast and go to a given uri vue-router
 * @param {string} body
 * @param {string} uri
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var warningAndPush = function (body, uri, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    warning(body, title, useI18n, config);
    push(uri);
};
/**
 * Push an info Toast
 * @param {string} body
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var info = function (body, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    if (useI18n)
        $.snotify.info($.t(body), title ? $.t(title) : undefined, config);
    else
        $.snotify.info(body, title || undefined, config);
};
/**
 * Push an info Toast and go to a given uri vue-router
 * @param {string} body
 * @param {string} uri
 * @param {string} title
 * @param {boolean} useI18n
 * @param {SnotifyToastConfig} config
 */
export var infoAndPush = function (body, uri, title, useI18n, config) {
    if (useI18n === void 0) { useI18n = true; }
    info(body, title, useI18n, config);
    push(uri);
};
//# sourceMappingURL=toast.helper.js.map